import Image from 'next/image';
import { Attribute } from '@strapi/strapi';
import { useTheme } from 'styled-components';

import CMSLink from '@tmh-website/components/shared/CMSLink';
import { isValidLinkField } from '@tmh-website/shared/cms';
import { Color } from '@tmh-website/shared/colors';
import { LocalePrefix } from '@tmh-website/shared/const';
import StyledTypo from '@tmh-website/styles/typo';

import * as Styled from './FooterPartnersBlock.styles';

interface FooterPartnersBlock {
  title?: string;
  text?: string;
  entries: Attribute.GetValues<'navigation.footer-logos-entry'>[];
  isStandaloneMode: boolean;
  locale: LocalePrefix;
  isCertificates?: boolean;
}

const FooterPartnersBlock = ({
  title,
  text,
  entries,
  isStandaloneMode,
  locale,
  isCertificates,
  ...props
}: FooterPartnersBlock) => {
  const { textOpacity } = useTheme();

  return (
    <div {...props}>
      {title && (
        <StyledTypo.Typography $style='h6' as='span'>
          {title}
        </StyledTypo.Typography>
      )}
      {entries && entries.length > 0 && (
        <Styled.LogosContainer>
          {entries.map(entry => {
            const logo = isCertificates ? (
              <Styled.Certificate
                key={entry.image.url}
                as={isStandaloneMode ? 'img' : Image}
                src={entry.image.url}
                alt={entry.image.alternativeText}
                width={entry.image.width}
                height={entry.image.height}
              />
            ) : (
              <Styled.LogoContainer key={entry.image.url} as={isValidLinkField(entry.link) ? 'a' : 'div'}>
                <Styled.Logo
                  as={isStandaloneMode ? 'img' : Image}
                  src={entry.image.url}
                  alt={entry.image.alternativeText}
                  width={entry.image.width}
                  height={entry.image.height}
                />
              </Styled.LogoContainer>
            );
            return isValidLinkField(entry.link) ? (
              <CMSLink key={entry.image.url} link={entry.link} isStandaloneMode={isStandaloneMode} locale={locale}>
                {logo}
              </CMSLink>
            ) : (
              logo
            );
          })}
        </Styled.LogosContainer>
      )}
      {text && (
        <Styled.Text
          input={text}
          typographyProps={{
            $style: 'uiTextSmall',
            $opacity: textOpacity,
            $color: Color.Neutral_0_White,
          }}
        />
      )}
    </div>
  );
};

export default FooterPartnersBlock;
